import UserSearchField from './UserSearchField';
import UserSearchFieldContainer from './UserSearchField.container';
export default UserSearchFieldContainer(UserSearchField);

//# sourceMappingURL=index.js.map